module.exports = __webpack_public_path__ + "img/column.cae2aea2.svg";